import { render, staticRenderFns } from "./BaseIOSBtn.vue?vue&type=template&id=dbb4a3ee"
import script from "./BaseIOSBtn.vue?vue&type=script&lang=js"
export * from "./BaseIOSBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports